export default __webpack_public_path__ + "static/Healthcare-7553d3e50e6c799d63f6cbf35c540d804613c85169226b2f1e229d2ef4179378.png";